import { MijnRoute } from '../mijn-navigatie.model';

export const PAGE_NOT_FOUND: MijnRoute = {
    path: 'pagina-niet-gevonden',
    navigationEvent: 'toPaginaNietGevonden',
    regex: /^\/pagina-niet-gevonden$/
};
